<template>
  <div>
    <search-form @search="onSearch" :fields="['name', 'phone', 'email', 'inbox']"/> 
    <div class="margin-top-2" v-if="showResult">
      <section class="search-tab-conversation-table-wrap">
        <ve-table
          :fixed-header="false"
          max-height="calc(100vh - 11.4rem)"          
          :columns="columns"
          :table-data="tableData"
          :border-around="false"
        />
       
        <empty-state
          v-if="!uiFlags.conversation.isFetching && !conversationRecords.length"
          :title="$t('SEARCH.EMPTY_STATE')"
        />
        <div v-if="uiFlags.conversation.isFetching" class="loader">
          <spinner />
          <span>{{ $t('SEARCH.SEARCHING_STATE') }}</span>
        </div>
      </section>
      
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { frontendURL } from 'dashboard/helper/URLHelper';
import timeMixin from 'dashboard/mixins/time';

import { VeTable } from 'vue-easytable';
import Spinner from 'shared/components/Spinner.vue';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import SearchForm from './SearchForm';


export default {
  mixins: [timeMixin],
  components: {
    VeTable,
    Spinner,
    EmptyState,
    SearchForm
  },
  data() {
    return {      
      showResult: false
    };
  },  
  computed: {
    ...mapGetters({
      conversationRecords: 'conversationSearch/getConversationRecords',
      uiFlags: 'conversationSearch/getUIFlags',
      isAccountTypeParent: 'isAccountTypeParent',
    }),    
    tableData() {
      if (this.uiFlags.conversation.isFetching) {
        return [];
      }
      return this.conversationRecords.map(item => {        
        return {
          ...item,          
          link: frontendURL(`accounts/${item.account_id}/conversations/${item.id}`),          
        };
      });
    },
    columns() {
      const columns =  [
        {
          field: 'id',
          key: 'id',
          title: "#",
          fixed: 'left',
          align: this.isRTLView ? 'right' : 'left',         
          width: 90,
          renderBodyCell: ({ row }) => {
            if(this.$route.params.accountId != row.account_id){
              return (
                <a href={row.link}>
                  {`#${row.id}`}
                </a>
              );
            }else{
              return (
                <router-link
                  to={row.link}
                  class="user-name"
                >
                  {row.id}
                </router-link>
              )
            }
          },          
        },
        {
          field: 'contact',
          key: 'contact',
          title: this.$t("SEARCH.LIST.HEADER.CONTACT"),
          fixed: 'left',
          align: this.isRTLView ? 'right' : 'left',         
          width: 200,
          renderBodyCell: ({ row }) => (
            <div class="row--user-block">                
              <div class="user-block">
                <h6 class="sub-block-title text-truncate">
                  {row.contact.name}
                </h6>
                {row.contact?.phone_number}
                <br/>{ row.contact?.email }
              </div>
            </div>        
          ),          
        },        
        {
          field: 'inbox',
          key: 'inbox',          
          title: this.$t("SEARCH.LIST.HEADER.INBOX"),
          align: this.isRTLView ? 'right' : 'left',
          width: 260,
          renderBodyCell: ({ row }) => {            
            return (row.inbox ? row.inbox.name : '---');
          },  
        },
        {
          field: 'status',
          key: 'status',          
          title: this.$t("SEARCH.LIST.HEADER.STATUS"),
          align: this.isRTLView ? 'right' : 'left',
          width: 100,
          renderBodyCell: ({ row }) => {            
            return this.$t(`CHAT_LIST.CHAT_STATUS_FILTER_ITEMS.${row.status}.TEXT`);
          },
        },
        {
          field: 'created_at',
          key: 'created_at',
          title: this.$t("SEARCH.LIST.HEADER.CREATED_AT"),
          align: this.isRTLView ? 'right' : 'left',          
          width: 100,
          renderBodyCell: ({ row }) => {            
            return this.messageStamp(
              new Date(row.created_at),
              'dd/MM/yy - HH:mm'
            );
          },
        },
        {
          field: 'last_activity_at',
          key: 'last_activity_at',          
          title: this.$t("SEARCH.LIST.HEADER.LAST_ACTIVITY"),
          align: this.isRTLView ? 'right' : 'left',
          width: 100,
          renderBodyCell: ({ row }) => {            
            return this.messageStamp(
              new Date(row.last_activity_at),
              'dd/MM/yy - HH:mm'
            );
          },
        },        
      ];
      if(this.isAccountTypeParent){
        return [...columns.slice(0, 1),...[{
          field: 'account',
          key: 'account',          
          title: 'Conta',
          align: this.isRTLView ? 'right' : 'left',
          width: 200,
          renderBodyCell: ({ row }) => {
            return row.account?.name ?? '---';
          },
        },], ...columns.slice(1) ];

      }
      return columns;
    },
  },  
  methods: {
    onSearch(data) {
      this.showResult = data !== null;
      if(!data || Object.keys(data).length == 0){
        this.$store.dispatch('conversationSearch/clearSearchResults', { type: 'conversation' });
        return;
      }      
      this.$store.dispatch('conversationSearch/conversationSearch', {
        contact_name: data.name,
        contact_phone: data.phone,
        contact_email: data.email,
        inbox: data.inbox ? data.inbox.id : null,
        subaccount: data.subaccount ? data.subaccount.id : null
      });
    }
  },
};
</script>
<style lang="scss" scoped>  
  .search-tab-conversation-table-wrap{
    .loader {
      align-items: center;
      display: flex;
      font-size: var(--font-size-default);
      justify-content: center;
      padding: var(--space-big);
    }
  }
</style>

